<template>
  <div class="uploadField">
    <label class="subtitle-2 black--text">
      {{ field.label }}
      <span v-if="this.field.required==1" class="orange--text text--darken-3">*</span>
      <span v-else class="orange--text text--darken-3">optionel</span>
    </label>
    <div class="files">
      <template v-if="field.config.multiple==true">
        <template v-for="(file,i) in model">
          <template v-if="file">
            <file-upload :key="file.id" v-model="model[i]" />
          </template>
        </template>
        <file-upload v-if="model" v-model="model[model.length]" @uploaded="update()" />
      </template>

      <template v-else>
        <file-upload v-model="model" @uploaded="update()" />
      </template>
    </div>
    <div class="errorMsg" v-if="block.errorMessages">{{block.errorMessages[0]}}</div>
    <div class="hint" v-if="field.hint">{{field.hint}}</div>
  </div>
</template>

<script>
import FileUpload from "../../FileUpload.vue";
import FieldMixin from "./FieldMixin";
export default {
  mixins: [FieldMixin],
  name: "FieldUpload",
  components: {
    FileUpload
  },
  data: function() {
    return {
      files: null
    };
  },
  mounted() {
    if (this.field.config.multiple === true && this.model === null) {
      this.model = [];
    }
  },
  methods: {
    validate: function() {
      if (this.field.required === 1) {
        let valid = true;
        for (let index = 0; index < this.model.length; index++) {
          const file = this.model[index];
          if (!file) {
            valid = false;
            this.addError(this.block.id,"Champ obligatoire");
          }
        }
        this.isValid = valid;
      } else {
        this.isValid = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.uploadField {
  border: 1px solid #dedede;
  border-radius: 10px;
  padding: 20px;
  position: relative;
  width: 90%;
  margin-top: 20px;
  &.readonly {
    border: none;
    padding: 20px 0;
    label {
      padding: 0;
    }
  }
  label {
    background-color: white;
    padding: 0 10px;
    font-weight: bold;
    position: absolute;
    top: 0;
    transform: translateY(-50%);
  }
  .files {
    display: flex;
    .imageUpload {
      margin: 0 10px;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }

    .fileUploaded {
      position: relative;
      height: 150px;
      width: 150px;
      background-size: cover;
      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: none;
      }
    }
  }
}
</style>
